import tealium from '../../tealium';
import { registerAnalyticsEventHandler } from '../registry';
import { IDataLayer } from '../../tealium/data_layer';

const defaultData: IDataLayer = {
  event_name: 'product_images_navigation',
  event_category: 'product_images',
  event_action: null, // <swipe or click>
  event_label: null, // <productID>
  alt_image_placement: null, // <PDP or PLP>
  alt_image_text: null // <Image Alt Text or File Name>
};

function trackAltImageClick(_: string, eventData: IDataLayer = {}) {
  const data = tealium.dataLayer?.data || {};
  eventData.event_action = eventData.altImageAction;
  eventData.event_label = [data.product_id];
  eventData.alt_image_placement = [data.page_template];
  eventData.alt_image_text = [
    data.product_impression_sku_large_image_url[eventData.altImagePosition]
  ];
  tealium.evtLink({ ...defaultData, ...eventData });
}

registerAnalyticsEventHandler('altImage', trackAltImageClick);
